//

var urlString = process.env.REACT_APP_API_URL;
// var urlString = "https://betelapi.trpwpartners.com/";

export const PdfApiUrl = `${urlString}AddMediaS3`;
export const ImageApiUrl = `${urlString}AddMediaS3`;
